module.exports = __webpack_public_path__ + "static/media/reforge_logo_v3.9a618feb.png";